<template>
    <div class="project-outlier-detection-container container-fluid mt-4 mb-4">
        <div class="row mt-2">
            <div class="col mx-auto">
                <h4>We analyzed <b>{{ project.num_of_rows }}</b> records
                    <br>
                </h4>
            </div>
        </div>
        <div v-if="columnsToRun.length" class="my-2">
            <div class="row">
                <div class="col-lg-6 col-md-9 col-sm-12 offset-lg-3 offset-md-1 offset-sm-0 text-left">
                    <h3>Select a column from the Dataset and Click "Run" to see the results</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-9 col-sm-12 offset-lg-3 offset-md-1 offset-sm-0 text-left">
                    <div class="form-group text-left">
                        <label class="pl-0 pb-1" for="column">Available Columns:</label>
                        <select class="form-control" id="column" v-model="selectedColumn">
                            <option
                                v-bind:value="column"
                                v-for="column in columnsToRun">
                                {{ column.columnName }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-lg-3 col-md-6 col-sm-12 mx-auto">
                    <button class="btn btn-primary" id="detect"
                            @click="runFraudDetectionOnSelectedColumn">Run
                    </button>
                </div>
            </div>
        </div>
        <div v-if="!columnsToRun.length" class="my-4">
            <div class="row">
                <div class="col-lg-6 col-md-9 col-sm-12 offset-lg-3 offset-md-1 offset-sm-0 text-center">
                    <h3><i class="fas fa-exclamation-triangle warning mb-3"></i>
                        <br>
                        Your dataset does not include any columns eligible for Fraud Detection.<br><br>
                        Please upload another dataset.
                    </h3>
                </div>
            </div>
        </div>


        <project-results-preview-data v-bind:preview-data="previewData"
                                      v-bind:number-of-rows="numberOfRows"></project-results-preview-data>
        <modal-component></modal-component>
    </div>
</template>
<script>

    import {mapActions, mapGetters} from 'vuex';

    export default {
        props: {
            project: Object
        },
        mounted() {
            this.getOutlierDetectionResultsFromAPI();
        },
        data: function () {
            return {
                columnsToRun: [],
                selectedColumn: {
                    columnIndex: 0,
                    columnName: ''
                },
                numberOfRows: 0,
                previewData: {
                    headers: [],
                    rows: []
                }
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'openModal',
                'setLoading',
                'setMessage',
                'requestRecipeFromAPI',
                'setModalAllowClose',
                'handleError'
            ]),

            getOutlierDetectionResultsFromAPI() {
                let instance = this;
                instance.requestRecipeFromAPI(instance.project)
                    .then(function (response) {
                        const rows = response.data.parsedCSV.rows;
                        instance.numberOfRows = response.data.parsedCSV.numberOfRows;
                        instance.previewData.headers = response.data.parsedCSV.headers;
                        instance.previewData.rows = rows;
                        instance.initColumnsToRun(response.data.validColumns);

                    })
                    .catch(function (error) {
                        instance.handleError(error)
                    });
            },
            initColumnsToRun(validColumns) {
                for (let i = 0; i < this.previewData.headers.length; i++) {
                    if (validColumns[i] === "Valid") {
                        this.columnsToRun.push({
                            columnIndex: this.previewData.headers[i].columnIndex,
                            columnName: this.previewData.headers[i].value
                        })
                    }
                }
                this.selectedColumn = this.columnsToRun[0];
            },
            runFraudDetectionOnSelectedColumn() {
                let instance = this;
                const url =
                    process.env.MIX_API_URL + this.project.recipe.api_path +
                    '/detect?projectId=' + this.project.code +
                    '&columnIndex=' + this.selectedColumn.columnIndex
                this.openModal();
                this.setLoading(true);
                this.setModalAllowClose(false);
                this.setMessage('');
                axios.post(
                    url,
                    {}, {headers: {'Bearer': process.env.MIX_API_AUTH_TOKEN}})
                    .then(function (response) {
                        console.log(response);
                        instance.setLoading(false);
                        instance.setModalAllowClose(true);
                        let fraudDetectionMessage = '<div class="fraud-message my-3">';
                        if (response.data.containsAnomalousNumbers)
                            fraudDetectionMessage += '<i class="fas my-3 fa-exclamation-circle red"></i><br>' +
                                '<div class="explanation">We have analyzed the data for the "<b>' + instance.selectedColumn.columnName + '</b>" column and ' +
                                'there is <b>indication</b> that the dataset has been altered manually.<br><br>We suggest to explore further!</div>'
                        else
                            fraudDetectionMessage += '<i class="fas my-3 fa-check-circle green"></i><br>' +
                                '<div class="explanation">We have analyzed the data for the "<b>' + instance.selectedColumn.columnName + '</b>" column and there is <b>no indication</b> that the dataset was altered manually.</div>'

                        instance.setMessage(fraudDetectionMessage);
                    })
                    .catch(function (error) {
                        instance.handleError(error);
                    });
            }
        }
    }

</script>
<style lang="scss">

    @import "../../sass/variables";

    .preview-data-message {
        color: $blue;
    }

    select#column {
        font-size: 1.2rem;
    }

    button#detect {
        font-size: 1.5rem;
    }

    .fraud-message {
        font-size: 1.5rem;

        i {
            font-size: 3.5rem;
        }
    }

    .warning {
        color: $yellow;
        font-size: 3rem;
    }

</style>
